import { render, staticRenderFns } from "./french_wordList.vue?vue&type=template&id=8c8a6d08&scoped=true&xmlns%3A=true"
import script from "./french_wordList.vue?vue&type=script&lang=js"
export * from "./french_wordList.vue?vue&type=script&lang=js"
import style0 from "./french_wordList.vue?vue&type=style&index=0&id=8c8a6d08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8a6d08",
  null
  
)

export default component.exports